/*
 * Pack skate -10 % (Streetart)
 *
 * Applique ou retire automatiquement deux codes de remise natifs Shopify selon le contenu du panier :
 *  - codePack : -10 % sur les pieces du pack, des que le panier contient board, trucks, roues,
 *    roulements, visserie et grip (grip a design ou grip Jessup) ;
 *  - codeGrip : grip Jessup offert, ajoute seulement si le Jessup est dans le panier.
 * L'etat du panier vient de /cart?view=packskate (templates/cart.packskate.liquid), qui lit les tags.
 * Non-cumul : si le client a deja un autre code, on ne le remplace jamais et on retire les codes pack.
 * Configuration : window.PackSkate (snippets/pack-skate-config.liquid).
 */
(function () {
  'use strict';

  var CFG = window.PackSkate;
  if (!CFG || !window.fetch || window.__packSkateLoaded) return;
  window.__packSkateLoaded = true;

  var ROOT = (CFG.root || '/cart').replace(/\/$/, '');
  var OURS = [CFG.codePack, CFG.codeGrip].map(function (c) { return String(c).toUpperCase(); });
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var busy = false;
  var pending = false;

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // Ecoute toutes les modifications du panier faites par le theme (fetch) ou par jQuery (XHR).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (CART_MUTATION.test(url)) request.then(schedule, function () {});
    return request;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__packSkate = CART_MUTATION.test(String(url || ''));
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__packSkate) this.addEventListener('loadend', schedule);
    return xhrSend.apply(this, arguments);
  };

  function upper(list) {
    return (list || []).map(function (c) { return String(c).toUpperCase(); });
  }

  function sameSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (c) { return b.indexOf(c) >= 0; });
  }

  function readState() {
    var state = nativeFetch(ROOT + '?view=packskate', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t); });
    var cart = nativeFetch(ROOT + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); });
    return Promise.all([state, cart]);
  }

  function currentCodes(state, cart) {
    // /cart.js liste aussi les codes non applicables ; le gabarit Liquid sert de secours.
    if (Array.isArray(cart.discount_codes)) {
      return upper(cart.discount_codes.map(function (d) { return d.code; }));
    }
    return upper(state.codes);
  }

  function wantedCodes(state, current) {
    var foreign = current.filter(function (c) { return OURS.indexOf(c) < 0; });
    if (foreign.length) return foreign; // non cumulable : le code du client est conserve
    if (!state.complete) return [];
    var wanted = [OURS[0]];
    // Le code grip offert rend gratuits tous les Jessup du panier : un seul par board.
    var jessupQty = state.jessup_qty || 0;
    if (jessupQty > 0 && jessupQty <= (state.board_qty || 0)) wanted.push(OURS[1]);
    return wanted;
  }

  function applyCodes(codes) {
    return nativeFetch(ROOT + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/update ' + r.status);
      return r.json();
    });
  }

  function refreshTheme() {
    var cart = window.theme && window.theme.Cart;
    if (cart && typeof cart.updateData === 'function' && typeof cart.updateCart === 'function') {
      return cart.updateData().then(function () { return cart.updateCart(); });
    }
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    return Promise.resolve();
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    readState()
      .then(function (res) {
        var state = res[0];
        var cart = res[1];
        var current = currentCodes(state, cart);
        var wanted = wantedCodes(state, current);
        if (sameSet(current, wanted)) return false;
        return applyCodes(wanted).then(function () { return true; });
      })
      .then(function (changed) {
        if (changed) return refreshTheme();
      })
      .catch(function (err) {
        if (window.console) console.warn('[Pack skate]', err);
      })
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  // Panier rempli avant l'arrivee sur la page (autre onglet, retour du checkout, etc.).
  // Rien a faire si le panier est vide au chargement : on evite deux requetes par page vue.
  function initialSync() {
    var loaded = window.theme && window.theme.loadedCartData;
    if (loaded && loaded.item_count === 0) return;
    schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync);
  } else {
    initialSync();
  }
  window.PackSkate.sync = schedule;
})();
